// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__liUKt","left":"Footer_left__ze4q6","follow":"Footer_follow__sCN1m","copyright":"Footer_copyright__osNfm","footer_dark":"Footer_footer_dark__p-tPg"};